import './autorizacao-dados-guia-controller';
import './autorizacao-guia-form-controller';
import './historico-autorizacao-controller';
import './historico-autorizacao-consulta-controller';
